export default __webpack_public_path__ + "static/media/instagram-v1-rt30.5c48aee8.svg";